export default { sha: '8e6369330ce8c4db0217e697b8597b92db46ecb5', buildNumber: 'undefined' }
